<!-- Minimal statistics section start -->
<section id="minimal-statistics">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Minimal Statistics Cards</div>
      <p class="content-sub-header mb-1">Statistics on minimal cards.</p>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-body text-left">
                <h3 class="mb-1 danger">278</h3>
                <span>New Projects</span>
              </div>
              <div class="media-right align-self-center">
                <i class="ft-briefcase danger font-large-2 float-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-body text-left">
                <h3 class="mb-1 success">156</h3>
                <span>New Clients</span>
              </div>
              <div class="media-right align-self-center">
                <i class="ft-user success font-large-2 float-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-body text-left">
                <h3 class="mb-1 warning">64.89 %</h3>
                <span>Conversion Rate</span>
              </div>
              <div class="media-right align-self-center">
                <i class="ft-pie-chart warning font-large-2 float-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-body text-left">
                <h3 class="mb-1 primary">423</h3>
                <span>Support Tickets</span>
              </div>
              <div class="media-right align-self-center">
                <i class="ft-life-buoy primary font-large-2 float-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-body text-left">
                <h3 class="mb-1 primary">278</h3>
                <span>New Posts</span>
              </div>
              <div class="media-right align-self-center">
                <i class="ft-book-open primary font-large-2 float-right"></i>
              </div>
            </div>
            <ngb-progressbar type="primary" [value]="80" class="progress-bar-sm" height="4px"></ngb-progressbar>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-body text-left">
                <h3 class="mb-1 warning">156</h3>
                <span>New Comments</span>
              </div>
              <div class="media-right align-self-center">
                <i class="ft-message-square warning font-large-2 float-right"></i>
              </div>
            </div>
            <ngb-progressbar type="warning" [value]="35" class="progress-bar-sm" height="4px"></ngb-progressbar>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-body text-left">
                <h3 class="mb-1 success">64.89 %</h3>
                <span>Bounce Rate</span>
              </div>
              <div class="media-right align-self-center">
                <i class="ft-trending-up success font-large-2 float-right"></i>
              </div>
            </div>
            <ngb-progressbar type="success" [value]="60" class="progress-bar-sm" height="4px"></ngb-progressbar>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-body text-left">
                <h3 class="mb-1 danger">423</h3>
                <span>Total Visits</span>
              </div>
              <div class="media-right align-self-center">
                <i class="ft-map-pin danger font-large-2 float-right"></i>
              </div>
            </div>
            <ngb-progressbar type="danger" [value]="40" class="progress-bar-sm" height="4px"></ngb-progressbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- // Minimal statistics section end -->

<!-- Minimal statistics with bg color section start -->
<section id="minimal-statistics-bg">
  <div class="row">
    <div class="col-12 mb-1">
      <div class="content-header">Minimal Statistics With Background Color</div>
      <p class="content-sub-header mb-1">Statistics on minimal cards with background color.</p>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card card-inverse bg-warning">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-body text-left">
                <h3 class="card-text">278</h3>
                <span>New Projects</span>
              </div>
              <div class="media-right align-self-center">
                <i class="ft-briefcase font-large-2 float-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card card-inverse bg-success">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-body text-left">
                <h3 class="card-text">156</h3>
                <span>New Clients</span>
              </div>
              <div class="media-right align-self-center">
                <i class="ft-user font-large-2 float-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card card-inverse bg-danger">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-body text-left">
                <h3 class="card-text">64.89 %</h3>
                <span>Conversion Rate</span>
              </div>
              <div class="media-right align-self-center">
                <i class="ft-pie-chart font-large-2 float-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card card-inverse bg-primary">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-body text-left">
                <h3 class="card-text">423</h3>
                <span>Support Tickets</span>
              </div>
              <div class="media-right align-self-center">
                <i class="ft-life-buoy font-large-2 float-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card card-inverse bg-primary">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-left align-self-center">
                <i class="ft-book-open font-large-2 float-left"></i>
              </div>
              <div class="media-body text-right">
                <h3 class="card-text">278</h3>
                <span>New Posts</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card card-inverse bg-danger">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-left align-self-center">
                <i class="ft-message-square font-large-2 float-left"></i>
              </div>
              <div class="media-body text-right">
                <h3 class="card-text">156</h3>
                <span>New Comments</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card card-inverse bg-success">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-left align-self-center">
                <i class="ft-trending-up font-large-2 float-left"></i>
              </div>
              <div class="media-body text-right">
                <h3 class="card-text">64.89 %</h3>
                <span>Bounce Rate</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-12">
      <div class="card card-inverse bg-warning">
        <div class="card-content">
          <div class="card-body">
            <div class="media">
              <div class="media-left align-self-center">
                <i class="ft-map-pin font-large-2 float-left"></i>
              </div>
              <div class="media-body text-right">
                <h3 class="card-text">423</h3>
                <span>Total Visits</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- // Minimal statistics with bg color section end -->

<!-- Basic example section start -->
<section id="basic-examples">
  <div class="row">
    <div class="col-12 mb-1">
      <div class="content-header">Basic Examples</div>
      <p class="content-sub-header mb-1">Cards require a small amount of markup and classes to provide you with as much control as possible. These classes and markup are flexible though and can typically be remixed and extended with ease. For example, if your card has no flush content like images, feel free to put the <code>.card-body</code> class on the <code>.card</code> element to consolidate your markup.</p>
    </div>
  </div>

  <div class="row match-height">
    <div class="col-xl-3 col-lg-6 col-md-12">
      <div class="card overflow-hidden">
        <div class="card-content">
          <img class="card-img-top img-fluid" src="assets/img/photos/06.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Card title</h4>
            <p class="card-text">Icing powder caramels macaroon. Toffee sugar plum brownie pastry gummies jelly.</p>
            <button type="button" class="btn btn-warning">Go somewhere</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <img class="card-img img-fluid rounded mb-3" src="assets/img/photos/08.jpg" alt="Card image cap">
            <h4 class="card-title">Card title</h4>
            <p class="card-text">Sweet halvah dragée jelly-o halvah carrot cake oat cake. Donut jujubes jelly chocolate cake marzipan chocolate chocolate bar.</p>
            <button type="button" class="btn btn-success">Go somewhere</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-12">
      <div class="card">
        <div class="card-header pb-3">
          <h4 class="card-title">Card title</h4>
          <h6 class="card-subtitle text-muted mb-0">Support card subtitle</h6>
        </div>
        <div class="card-content">
          <img class="img-fluid" src="assets/img/photos/10.jpg" alt="Card image cap">
          <div class="card-body">
            <p class="card-text">Bear claw sesame snaps gummies chocolate.</p>
          </div>
          <div class="card-footer pt-0">
            <a class="card-link danger" href="javascript:;">Card link</a>
            <a class="card-link danger" href="javascript:;">Another link</a></div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-12">
      <div class="card">
        <div class="card-content">
          <div class="card-header">
            <h4 class="card-title">Card title</h4>
            <h6 class="card-subtitle text-muted mb-0">Support card subtitle</h6>
          </div>
          <div class="card-content">
            <div class="card-body">
              <img class="img-fluid" src="assets/img/photos/09.jpg" alt="Card image cap">
              <p class="card-text mt-2">Topping dessert marshmallow gummi bears chupa chups marzipan.</p>
            </div>
          </div>
        </div>
        <div class="card-footer pt-0">
          <a class="card-link info darken-2" href="javascript:;">Card link</a>
          <a class="card-link info darken-2" href="javascript:;">Another link</a>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- // Basic example section end -->

<!-- Content types section start -->
<section id="content-types">
  <div class="row">
    <div class="col-12 mb-1">
      <div class="content-header">Content Types</div>
      <p class="content-sub-header mb-1">Cards support a wide variety of content, including images, text, list groups, links, and more. Mix and match multiple content types to create the card you need.</p>
    </div>
  </div>

  <div class="row match-height">
    <div class="col-lg-4 col-md-6 col-sm-12">
      <div class="card">
        <div class="card-content">
          <img class="card-img-top img-fluid" src="assets/img/photos/14.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Basic</h4>
            <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            <button type="button" class="btn btn-danger">Go somewhere</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">List Group</h4>
          <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ul class="list-group">
              <li class="list-group-item">
                <span class="badge bg-primary float-right">7</span>Cras justo odio
              </li>
              <li class="list-group-item">
                <span class="badge bg-info float-right">2</span>Dapibus ac facilisis in
              </li>
              <li class="list-group-item">
                <span class="badge bg-warning float-right">1</span>Morbi leo risus
              </li>
              <li class="list-group-item">
                <span class="badge bg-success float-right">4</span>Porta ac consectetur ac
              </li>
            </ul>
          </div>
        </div>
        <div class="card-footer pt-0">
          <a class="card-link success" href="javascript:;">Card link</a>
          <a class="card-link success" href="javascript:;">Another link</a>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Carousel</h4>
          <h6 class="card-subtitle text-muted">Support card subtitle</h6>
        </div>
        <div class="card-content">
          <ngb-carousel>
            <ng-template ngbSlide>
              <img src="assets/img/photos/17.jpg" alt="First slide">
            </ng-template>
            <ng-template ngbSlide>
              <img src="assets/img/photos/13.jpg" alt="Second slide">
            </ng-template>
            <ng-template ngbSlide>
              <img src="assets/img/photos/12.jpg" alt="Third slide">
            </ng-template>
          </ngb-carousel>
          <div class="card-body">
            <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's
              content.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>
<!-- Content types section end -->

<!-- Card sizing section start -->
<section id="sizing">
  <div class="row match-height">
    <div class="col-12 mb-1">
      <div class="content-header">Sizing</div>
      <p class="content-sub-header mb-1">Constrain the width of cards via custom CSS, our predefined grid classes, or with custom styles using our grid mixins.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Project Info</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
            </div>
            <form class="form">
              <div class="form-body">
                <h6 class="mt-3"><i class="ft-user mr-2"></i>Personal Info</h6>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="projectinput1" class="sr-only">First Name</label>
                      <input type="text" id="projectinput1" class="form-control" placeholder="First Name" name="fname">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="projectinput2" class="sr-only">Last Name</label>
                      <input type="text" id="projectinput2" class="form-control" placeholder="Last Name" name="lname">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="projectinput3" class="sr-only">E-mail</label>
                      <input type="text" id="projectinput3" class="form-control" placeholder="E-mail" name="email">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="projectinput4" class="sr-only">Contact Number</label>
                      <input type="number" id="projectinput4" class="form-control" placeholder="Phone" name="phone">
                    </div>
                  </div>
                </div>
                <h6 class="mt-2"><i class="ft-check-circle mr-2"></i>Requirements</h6>
                <div class="form-group">
                  <label for="companyName" class="sr-only">Company</label>
                  <input type="text" id="companyName" class="form-control" placeholder="Company Name" name="company">
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="projectinput5" class="sr-only">Interested in</label>
                      <select id="projectinput5" name="interested" class="form-control">
                        <option value="none" selected="" disabled="">Interested in</option>
                        <option value="Design">Design</option>
                        <option value="Development">Development</option>
                        <option value="Illustration">Illustration</option>
                        <option value="Branding">Branding</option>
                        <option value="Video">Video</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="projectinput6" class="sr-only">Budget</label>
                      <select id="projectinput6" name="budget" class="form-control">
                        <option value="0" selected="" disabled="">Budget</option>
                        <option value="Less than 5000$">Less than 5000$</option>
                        <option value="5000$ - 10000$">5000$ - 10000$</option>
                        <option value="10000$ - 20000$">10000$ - 20000$</option>
                        <option value="More than 20000$">More than 20000$</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="projectinput8" class="sr-only">About Project</label>
                  <textarea id="projectinput8" rows="5" class="form-control" name="comment" placeholder="About Project"></textarea>
                </div>
              </div>
              <div>
                <button type="button" class="btn btn-primary mr-1"><i class="ft-check mr-2"></i>Save</button>
                <button type="button" class="btn btn-secondary"><i class="ft-x mr-2"></i>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">User Profile</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
            </div>
            <form class="form">
              <div class="form-body">
                <h6 class="mt-3"><i class="ft-eye mr-2"></i>About User</h6>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="userinput1" class="sr-only">Fist Name</label>
                      <input type="text" id="userinput1" class="form-control" placeholder="Name" name="name">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="userinput2" class="sr-only">Last Name</label>
                      <input type="text" id="userinput2" class="form-control" placeholder="Company" name="company">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="userinput3" class="sr-only">Username</label>
                      <input type="text" id="userinput3" class="form-control" placeholder="Username" name="username">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="userinput4" class="sr-only">Nick Name</label>
                      <input type="text" id="userinput4" class="form-control" placeholder="Nick Name" name="nickname">
                    </div>
                  </div>
                </div>
                <h6 class="mt-2"><i class="ft-mail mr-2"></i>Contact Info & Bio</h6>
                <div class="form-group">
                  <label for="userinput5" class="sr-only">Email</label>
                  <input class="form-control" type="email" placeholder="email" id="userinput5">
                </div>
                <div class="form-group">
                  <label for="userinput6" class="sr-only">Website</label>
                  <input class="form-control" type="url" placeholder="http://" id="userinput6">
                </div>
                <div class="form-group">
                  <label for="userinput8" class="sr-only">Bio</label>
                  <textarea id="userinput8" rows="5" class="form-control" name="bio" placeholder="Bio"></textarea>
                </div>
              </div>
              <div>
                <button type="button" class="btn btn-primary mr-1"><i class="ft-check mr-2"></i>Save</button>
                <button type="button" class="btn btn-secondary"><i class="ft-x mr-2"></i>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Card sizing section end -->

<!-- Text alignment section start -->
<section id="text-alignment">
  <div class="row">
    <div class="col-12 mb-1">
      <div class="content-header">Text alignment</div>
      <p class="content-sub-header mb-1">You can quickly change the text alignment of any card—in its entirety or specific parts—with our text align classes.</p>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-4 col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title info">Text Align Left</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p class="card-text">Gummi bears I love oat cake gingerbread donut cotton candy pie biscuit tart. Chocolate cake chocolate cake I love marzipan cookie macaroon. Tart I love I love carrot cake carrot cake chupa chups caramels. Carrot cake pastry cotton candy.</p>
            <p class="card-text">Dessert I love brownie biscuit topping I love chocolate cake gingerbread jelly beans. Chocolate cake cake cheesecake. Chocolate cake pastry macaroon.</p>
            <button type="button" class="btn btn-info">Go somewhere</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12">
      <div class="card text-center">
        <div class="card-header">
          <h4 class="card-title success">Text Align Center</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p class="card-text">Gummi bears I love oat cake gingerbread donut cotton candy pie biscuit tart. Chocolate cake chocolate cake I love marzipan cookie macaroon. Tart I love I love carrot cake carrot cake chupa chups caramels. Carrot cake pastry cotton candy.</p>
            <p class="card-text">Dessert I love brownie biscuit topping I love chocolate cake gingerbread jelly beans. Chocolate cake cake cheesecake. Chocolate cake pastry macaroon.</p>
            <button type="button" class="btn btn-success">Go somewhere</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12">
      <div class="card text-right">
        <div class="card-header">
          <h4 class="card-title danger">Text Align Right</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p class="card-text">Gummi bears I love oat cake gingerbread donut cotton candy pie biscuit tart. Chocolate cake chocolate cake I love marzipan cookie macaroon. Tart I love I love carrot cake carrot cake chupa chups caramels. Carrot cake pastry cotton candy.</p>
            <p class="card-text">Dessert I love brownie biscuit topping I love chocolate cake gingerbread jelly beans. Chocolate cake cake cheesecake. Chocolate cake pastry macaroon.</p>
            <button type="button" class="btn btn-danger">Go somewhere</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Text alignment section end -->

<!-- Header footer section start -->
<section id="header-footer">
  <div class="row">
    <div class="col-12 mb-1">
      <div class="content-header">Header and footer</div>
      <p class="content-sub-header mb-1">Add an optional header and/or footer within a card.</p>
    </div>
  </div>
  <div class="row match-height">
    <div class="col-lg-4 col-md-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Basic Card</h4>
          <p>Basic Card With Header & Footer</p>
        </div>
        <div class="card-content">
          <img class="img-fluid" src="assets/img/photos/02.jpg" alt="Card image cap">
          <div class="card-body">
            <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's
              content.</p>
            <a href="javascript:void(0);" class="card-link">Card link</a>
            <a href="javascript:void(0);" class="card-link">Another link</a>
          </div>
        </div>
        <div class="card-footer text-muted pt-0">
          <span class="float-left">3 hours ago</span>
          <span class="float-right">
            <a href="javascript:void(0);" class="card-link">Read More <i class="fa fa-angle-right"></i></a>
          </span>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Floating Action Button Card</h4>
          <p>Floating Action Button Card With Header & Footer</p>
        </div>
        <div class="card-content">
          <div class="card-img">
            <img class="img-fluid" src="assets/img/photos/07.jpg" alt="Card image cap">
            <a class="btn btn-floating halfway-fab btn-large bg-danger"><i class="ft-plus"></i></a>
          </div>
          <div class="card-body">
            <p class="card-text">Bear claw sesame snaps gummies chocolate.</p>
            <a class="card-link danger" href="javascript:;">Card link</a>
            <a class="card-link danger" href="javascript:;">Another link</a>
          </div>
        </div>
        <div class="card-footer text-muted pt-0">
          <span class="float-left">1 day ago</span>
          <span class="tags float-right">
            <span class="badge bg-success mb-1 mr-1">Technology</span>
            <span class="badge bg-warning">Gaming</span>
          </span>
        </div>
      </div>
    </div>

    <div class="col-lg-4 col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Carousel</h4>
          <p>Carousel Card With Header & Footer</p>
        </div>
        <div class="card-content">
          <ngb-carousel>
            <ng-template ngbSlide>
              <img src="assets/img/photos/01.jpg" class="d-block w-100" alt="First slide">
            </ng-template>
            <ng-template ngbSlide>
              <img src="assets/img/photos/05.jpg" class="d-block w-100" alt="Second slide">
            </ng-template>
            <ng-template ngbSlide>
              <img src="assets/img/photos/10.jpg" class="d-block w-100" alt="Third slide">
            </ng-template>
          </ngb-carousel>
          <div class="card-body">
            <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's
              content.</p>
            <a href="javascript:void(0);" class="card-link">Card link</a>
            <a href="javascript:void(0);" class="card-link">Another link</a>
          </div>
        </div>
        <div class="card-footer text-muted pt-0">
          <span class="float-left">2 days ago</span>
          <span class="tags float-right">
            <span class="badge bg-primary mr-1">Branding</span>
            <span class="badge bg-danger">Design</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Header footer section end -->
